import "assets/scss/bootstrap.scss";
import './i18n';
import App from './app';
import { createRoot } from 'react-dom/client';
import React from 'react';

const DEBUG = process.env.REACT_APP_DEBUG === '1';

if (!DEBUG) {
  console.error = () => {};
}
const OriginalResizeObserver = window.ResizeObserver;

window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App tab="home" />);
